import { BusinessUnitEmailContactResolverBase } from './business-unit-email-contact.resolver.base';
import { BusinessUnitEmailContactService } from './business-unit-email-contact.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class BusinessUnitEmailContactResolver extends BusinessUnitEmailContactResolverBase {

  constructor(protected service: BusinessUnitEmailContactService) {
    super(service);
  }
}



